import { Slot } from '@radix-ui/react-slot'
import * as React from 'react'

import { accents, bases, colorSchemes } from './ColorScheme.config'

export type TcolorScheme = {
  base?: keyof typeof bases
  accent?: keyof typeof accents
  interactive?: 'loContrast' | 'hiContrast'
}

type TColorSchemeOwnProps = TcolorScheme & {
  asChild?: boolean
}

type TColorSchemeProps = React.HTMLAttributes<HTMLDivElement> &
  TColorSchemeOwnProps

/**
 * @experimental Component has not been finalised. Further design input required. Use with caution.
 */
export const ColorScheme = React.forwardRef<HTMLDivElement, TColorSchemeProps>(
  (
    { base = '', accent = '', interactive = '', asChild = false, ...rest },
    ref
  ) => {
    const Component = asChild ? Slot : 'div'

    // Build style object - config ensures values are always strings (never undefined)
    const style = {
      ...(interactive && colorSchemes[`interactive-${interactive}`]),
      ...(accent && colorSchemes[`accent-${accent}`]),
      ...(base && colorSchemes[`base-${base}`])
    } as React.CSSProperties

    return <Component {...rest} ref={ref} style={style} />
  }
)

ColorScheme.displayName = 'ColorScheme'
